import { CustomModal } from "components/custom-modal";
import { createModalTrigger, useModalControls } from "hooks/use-modal-controls";
import { Button, Box, Input, Text, Grid } from "@chakra-ui/react";
import { useState } from "react";
import { ExtratoEndpoints } from "./utils";
import { CloseIcon } from "components/vectors/close-icon";
import { InputField } from "components/input-field";
import { AddIcon } from "@chakra-ui/icons";
import { Toast } from "components/toast";

const eventName = "openModalCreateExtrato";

interface CreateExtratoParams {
  onUpdate: () => void;
}

export function ModalCreateExtrato() {
  const [beneficio, setBeneficio] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const { isOpen, onClose, params } =
    useModalControls<CreateExtratoParams>(eventName);

  const handleCreate = async () => {
    if (!beneficio.trim() || isCreating) return;
    try {
      setIsCreating(true);
      await ExtratoEndpoints.createExtrato(beneficio.trim());
      params?.onUpdate?.();
      onClose();
    } catch (error: any) {
      // Handle error if needed
      console.error("Erro ao criar extrato:", JSON.stringify(error));
      const msgInterface = error?.data?.msgInterface || "";
      Toast({
        title: "Erro ao criar extrato",
        description: msgInterface
      });
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <CustomModal
      modalTitle="Novo Extrato"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      modalFooter={
        <>
          <Button
            onClick={handleCreate}
            isLoading={isCreating}
            leftIcon={<AddIcon />}
          >
            Criar
          </Button>
          <Button onClick={onClose} leftIcon={<CloseIcon />} variant="outline">
            Fechar
          </Button>
        </>
      }
    >
      <InputField
        title="Benefício"
        value={beneficio}
        onChange={(e) => setBeneficio(e.target.value)}
        inputProps={{ placeholder: "Digite o benefício" }}
        variant="outline-custom"
      />
    </CustomModal>
  );
}

export const openModalCreateExtrato =
  createModalTrigger<CreateExtratoParams>(eventName);
